import {
  MatchedRoute,
  RouteConfig,
  RouteConfigComponentProps
} from 'react-router-config'

import { IPageComponent } from './pageComponent'

export enum PageType {
  HOME = 'home',
  FEATURE = 'feature',
  POPULAR = 'popular',
  CATEGORY = 'category',
  TAG = 'tag',
  ATTRIBUTE = 'attribute',
  SEARCH = 'search',
  LANDING = 'landing',
  OTHER = 'other'
}

export interface IRouteConfig extends RouteConfig {
  component?: IPageComponent<RouteConfigComponentProps<any> | {}>
  pageType?: PageType
  routes?: IRouteConfig[]
  searchBar?: boolean
}

export interface IMatchedRoute<T> extends MatchedRoute<T> {
  route: IRouteConfig
}
